// ================================
// Constants and Initialization
// ================================
const parallaxEls = document.querySelectorAll('[data-speed]');
const observerOptions = { threshold: 0.1 };
const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

// Ensure IntersectionObserver is available
const observer =
  typeof IntersectionObserver !== 'undefined'
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      }, observerOptions)
    : null;

// ================================
// Initialization Functions
// ================================
function initializeParallax() {
  if (!observer) return; // Skip initialization if IntersectionObserver is not available
  parallaxEls.forEach((el) => {
    el.dataset.initialTop = el.getBoundingClientRect().top + window.scrollY;
    observer.observe(el);
  });
}

if (!prefersReducedMotion) {
  initializeParallax();
  window.addEventListener('scroll', throttle(parallax));
  window.addEventListener('resize', throttle(parallax));
}

// ================================
// Parallax Scroll Handler
// ================================
function parallax() {
  parallaxEls.forEach((item) => {
    if (!item.classList.contains('is-visible')) return;

    const speed = parseFloat(item.dataset.speed || 0);
    const direction = getDirection(item);
    const initialTop = parseFloat(item.dataset.initialTop);
    const offset = calculateOffset(initialTop, speed, direction);

    item.style.transform = `${getBaseTransform(item)} translate3d(0, ${offset}px, 0)`;
  });
}

function getDirection(item) {
  let direction = item.dataset.direction || 'down';
  if (
    item.classList.contains('graphic--flipY') ||
    item.classList.contains('graphic--flipXY')
  ) {
    direction = direction === 'up' ? 'down' : 'up';
  }
  return direction;
}

function calculateOffset(initialTop, speed, direction) {
  const offset = (window.scrollY + window.innerHeight - initialTop) * speed;
  return direction === 'up' ? -offset : offset;
}

function getBaseTransform(element) {
  if (element.classList.contains('graphic--flipX')) return 'scaleX(-1)';
  if (element.classList.contains('graphic--flipY')) return 'scaleY(-1)';
  if (element.classList.contains('graphic--flipXY')) return 'scale(-1)';
  return '';
}

// ================================
// Utility Functions
// ================================
function throttle(callback) {
  let ticking = false;
  return () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(() => {
        callback();
        ticking = false;
      });
    }
  };
}

export { parallax };
